export function startLoop(f) {
  let frameRequest;
  let lastT = Date.now();
  
  function loop() {
    let t = Date.now();
    f(t, t - lastT);
    lastT = t;
    frameRequest = requestAnimationFrame(loop);
  }

  loop();

  return function() {
    cancelAnimationFrame(frameRequest);
  }
}


// WEBPACK FOOTER //
// ./src/common.js